

import React, { useEffect, useContext } from "react";
import { SessionContext } from "./state/SessionContext";

import { StarFill, Trash, TagFill, TagsFill, Eye, Gear } from "react-bootstrap-icons";
import { SESSION_ACTIONS } from "./state/SessionReducer";
import { sendCommand } from "../components/Bridge";
import { useTranslation } from "react-i18next";
import {
  Item,
  Separator,
  Submenu,
} from "react-contexify";

function SessionListMenuItems({match}){

    const { sessionState : state, dispatchSessionState : dispatchState } = useContext(SessionContext);

    const { t } = useTranslation();

    const categorize = (categoryId, level) => {
      //console.log(categoryId, level);
      let ids = [];
      state.selectedRows.forEach((row) => {
        ids.push(row.id);
      });
      dispatchState({
        type: SESSION_ACTIONS.CATEGORIZE,
        ids: ids,
        categoryId : categoryId,
        level : level
      });
    }

    const toggleBookmark = () => {
      let allBookmarked = true;
      let ids = [];
      state.selectedRows.forEach((row) => {
        ids.push(row.id);
        if (!row.bookmark) {
          allBookmarked = false;
        }
      });
      dispatchState({
        type: SESSION_ACTIONS.TOGGLE_BOOKMARKS,
        ids: ids,
        bookmark : !allBookmarked
      });
    };
  
  
    useEffect(()=>{
        console.log("SessionListMenuItems effect");
    
        return (()=>{
            console.log("SessionListMenuItems effect done");
        });
    }, []);

    return (<>
      <Submenu label={<><TagsFill size="16"></TagsFill>{t("app.session.actions.categorize")}</>}>
        <Item disabled={state.selectedRows.length === 0} onClick={() => categorize(-1, -1)}><TagFill className="color" size="16" style={{ color: "transparent" }}></TagFill>{t("app.session.categorization.none")}</Item>
        <Separator></Separator>
        {state.categories.levelColors.map((level, index) =>
          index < 10 ?
            <Item key={"category-" + index} disabled={state.selectedRows.length === 0} onClick={() => categorize(index, level)}><TagFill className="color" size="16" style={{ color: "rgba(" + level.red + "," + level.green + "," + level.blue + "," + level.alpha + ")" }}></TagFill>{state.categories.names[index]}</Item> : <></>
        )}
        <Separator></Separator>
        <Item onClick={() => window.toggleOptions("session-category-management")}><Gear size="16" ></Gear>{t("app.session.categorization.title")} ...</Item>
      </Submenu>
      <Separator></Separator>
      <Item className="bookmark" disabled={state.selectedRows.length === 0} onClick={() => {
        toggleBookmark();
      }}><StarFill size="16"></StarFill>{t("app.session.actions.bookmark."+(state.selectedRows.length===state.data.length?"false":"true"))}</Item>
      <Item disabled={state.selectedRows.length !== 1} onClick={() => {
        sendCommand("session/replay", {sessionId:state.selectedRows[0].id, heroId : match.params.hero})
      }}><Eye size="16"></Eye>{t("app.session.actions.replay")}</Item>
      <Separator></Separator>,
      <Item className="delete" disabled={state.selectedRows.length === 0} onClick={() => {
        dispatchState({
          type: SESSION_ACTIONS.CONFIRM_DELETION,
          payload: true
        });
      }}><Trash size="16"></Trash>{t("app.session.actions.delete")}</Item>    
    </>)
}
export default SessionListMenuItems;